import { Helmet } from 'react-helmet-async';
import { useQuery } from '@tanstack/react-query';
import { ContactForm } from '../components/ContactForm';
import { settingsApi } from '../lib/api';

export function ContactPage() {
  const { data: settings } = useQuery({
    queryKey: ['public-settings'],
    queryFn: () => settingsApi.getPublic().then((res) => res.data),
    staleTime: 0, // Always refetch
    refetchOnMount: true,
  });

  return (
    <>
      <Helmet>
        <title>İletişim - {import.meta.env.VITE_APP_NAME || 'KUMBİLGİ'}</title>
        <meta name="description" content={`${import.meta.env.VITE_APP_NAME || 'KUMBİLGİ'} ile iletişime geçin`} />
      </Helmet>

      <div className="container-custom py-12">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">İletişim</h1>
          <p className="text-xl text-gray-600 mb-8">
            Sorularınız, önerileriniz veya teklif talepleriniz için bizimle iletişime geçebilirsiniz.
          </p>

          <div className="bg-white rounded-lg shadow-md p-8">
            <ContactForm />
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
            {settings?.email && (
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="font-semibold mb-2">Email</h3>
                <a
                  href={`mailto:${settings.email}`}
                  className="text-primary-600 hover:underline"
                >
                  {settings.email}
                </a>
              </div>
            )}
            {settings?.phone && (
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="font-semibold mb-2">Telefon</h3>
                <a
                  href={`tel:${settings.phone.replace(/\s/g, '')}`}
                  className="text-primary-600 hover:underline"
                >
                  {settings.phone}
                </a>
              </div>
            )}
            {settings?.address && (
              <div className="bg-gray-50 rounded-lg p-6 md:col-span-2">
                <h3 className="font-semibold mb-2">Adres</h3>
                <p className="text-gray-700 whitespace-pre-line">
                  {settings.address}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

